var intervalBoldCheckId = null;

function ready(callback) {
  // in case the document is already rendered
  if (document.readyState != "loading") callback();
  // modern browsers
  else if (document.addEventListener)
    document.addEventListener("DOMContentLoaded", callback);
  // IE <= 8
  else
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState == "complete") callback();
    });
}

function boldSelectOption(boldOptions) {
  try {
    const productPage = document.getElementsByClassName(
      "shopify-section-product-template",
    );
    if (productPage) {
      setTimeout(function () {
        boldOptions.forEach(function (item, index) {
          const findChildSize = item.querySelectorAll(".bold_option_set");
          if (findChildSize.length < 2) {
            item.classList.add("single-child");
          }
        });

        const selectOption = document.querySelectorAll(".bold_option_dropdown");

        if (selectOption) {
          selectOption.forEach(function (item) {
            const inner = item.querySelector(".bold_option_element");
            const iconDiv = document.createElement("div");
            iconDiv.classList.add("arrow-down");
            iconDiv.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
                              <path d="M3.41026 6.70968H2.58292L0 0.5H1.26457L2.99996 4.64698L4.73543 0.5H6L3.41699 6.70968H3.41026Z" fill="#231F20"></path>
                            </svg>`;
            if (inner) {
              inner.appendChild(iconDiv);
            }
          });
        }
      }, 100);
    }
  } catch (err) {
    console.log("err", err);
  }
}

function checkingBoldReady(cb) {
  const productPage = document.getElementsByClassName(
    "shopify-section-product-template",
  );

  if (productPage) {
    const check = function () {
      const boldOptions = document.querySelectorAll(".bold_options");
      if (boldOptions) {
        if (cb) {
          cb(boldOptions);
        }
        clearInterval(intervalBoldCheckId);
      }
    };
    intervalBoldCheckId = setInterval(check, 100);
  }
}

ready(function () {
  checkingBoldReady(boldSelectOption);

  const $ = jQuery;

  const formCustomBold = jQuery(".product-single__form");

  if (formCustomBold) {
    const boldOptions = jQuery(".bold_options");

    if (boldOptions) {
      function checkForChanges() {
        if ($(boldOptions).hasClass("bold_options_loaded")) {
          setTimeout(function () {
            const boldOptionsSet = $(formCustomBold).find(".bold_option_set");
            const boldSetOption2 = $(boldOptionsSet[1]);

            jQuery(boldOptions).after(
              "<div id='custom_sub-total' class='sub-total-calculation'></div>",
            );

            // Start checking checkbox
            jQuery(".bold_option_value label").click(function () {
              setTimeout(function () {
                const boldTotal = jQuery(
                  "[data-property-name=_boldVariantPrices]",
                );
                const val = jQuery(boldTotal).val();
                const totalContainer = jQuery("#custom_sub-total");

                let price = 0;

                if (meta) {
                  const currentProdPrice = meta.product.variants[0].price;
                  price = meta.product.variants[0].price;
                }

                if (val) {
                  const numbers = val.split(",");
                  const total = numbers.reduce(sumFunc);
                  const subTotal = (parseInt(total) + price) / 100;

                  jQuery(totalContainer).html(
                    `Total Price : <strong>${Shopify.currency.active}$${subTotal.toFixed(2)}</strong>`,
                  );

                  function sumFunc(total, num) {
                    return parseInt(total) + parseInt(num);
                  }
                } else {
                  const subTotal = parseInt(price) / 100;
                  jQuery(totalContainer).html(
                    `Total Price : <strong>${Shopify.currency.active}$${subTotal.toFixed(2)}</strong>`,
                  );
                }
              }, 150);
            });
            // End checking checkbox

            if (window.innerWidth < 600 && boldSetOption2) {
              const checkBoxes = $(boldSetOption2).find(".bold_option_value");
              const radios = $(boldSetOption2).find(".bold_option_radio");
              if (checkBoxes) {
                $(checkBoxes).each(function (index, item) {
                  $(radios[index]).addClass("__bs-bold-radio");
                  $(radios[index]).appendTo(item);
                });
              }
            }
          }, 300);
        } else {
          setTimeout(checkForChanges, 500);
        }
      }

      // End function checker
      checkForChanges();
    }
  }
});
